import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SALES_HOME, routeOpenForRole } from '../lib/sales-access';

/**
 * Deny-by-default for the `sales` role (CRM-API-0 Part B). A sales user who
 * reaches a route outside lib/sales-access.ts's SALES_ROUTES — a typed URL, an
 * old bookmark, a link on a screen they can open — lands on SALES_HOME instead
 * of a page whose every call the API refuses. Every other role renders the
 * route exactly as before.
 */
export default function SalesRouteGate() {
  const { user } = useAuth();
  const location = useLocation();
  if (!routeOpenForRole(user?.role, location.pathname)) {
    return <Navigate to={SALES_HOME} replace />;
  }
  return <Outlet />;
}
